import { InconsistentOrdersPage } from "@/components/inconsistent-orders.ts/inor-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/inconsistent-orders/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <InconsistentOrdersPage />;
}
